/**
 * Ajax Handler (Axios)
 */
 import axios from 'axios';
 import { ajax } from 'jquery';
 import Qs from 'qs';

 class AjaxHandler {
	 constructor() {
		 this.$ = jQuery;

		 /* Axios cancel params */
		 this.CancelToken = axios.CancelToken;
		 this.source = this.CancelToken.source();
	 }

	 /**
	  * Trigger an Ajax Request with various options and returns the output
	  * Use promise to return the contents
	  * @param {object} formData FormData
	  * @param {string} method POST / GET
	  * @param {object} loadingOverlayContainerContainer Non-mandatory loading animation (element)
	  */
	 _request(formData, method = 'POST', $loadingOverlayContainer = false, force = false) {
		 let isCanceled = false;

		 if (this.source && !force) {
			 this.source.cancel('Cancelling previous request.');
			 isCanceled = true;
		 }

		 this.source = axios.CancelToken.source();

		 if ($loadingOverlayContainer) {
			 $($loadingOverlayContainer).LoadingOverlay('show', {
				 imageClass: 'jquery-loading-overlay-icon',
				 image: window.ajax.templateUrl + '/assets/svg/loading.svg',
				 zIndex: 800,
				 imageResizeFactor: 1,
				 background: 'rgba(255, 255, 255, 0.09)'
			 });
		 }

		 const options = {
			 method: method,
			 headers: { 'content-type': 'application/x-www-form-urlencoded' },
			 is_canceled: isCanceled,
			 data: formData,
			 cancelToken: this.source.token
		 };

		 return axios(window.ajax.url, options).then(res => {
			 if ($loadingOverlayContainer)
				 $($loadingOverlayContainer).LoadingOverlay('hide', true);
			 return res;
		 }).catch(error => {
			 if (axios.isCancel(error)) {
				 console.log(error);
			 } else {
				 console.log(error.response);
			 }
		 });
	 }
 }

 export default AjaxHandler;
